export const MANY_PENDING_WORK_THRESHOLD = 4;

export function getOpenWorkSeverity(count) {
  const pending = Number(count || 0);
  if (pending <= 0) return "clear";
  if (pending < MANY_PENDING_WORK_THRESHOLD) return "few";
  return "many";
}

export function getOpenWorkSeverityLabel(count) {
  const severity = getOpenWorkSeverity(count);
  if (severity === "few") return "Few pending";
  if (severity === "many") return "Many pending";
  return "Queue clear";
}
